import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  considerTimePeriods,
  considerTimePeriodsForUnifiedMenu,
} from '../../../reducers/menuSlice';
import { selectCartModality } from '../../../selectors/cart';
import {
  selectActiveRestaurantTimezone,
  selectedStageSelector,
} from '../../../selectors/restaurant';
import { TIME_PERIOD_CHECK_INTERVAL } from '../../../utils/constants';
import { getMenuUnificationFeatureFlag } from '../../../utils/session-storage';
import { selectInfoSlashCommandOptions } from '../../../redux/features/config/config.selector';

/**
 * Polls the clock to roll the menu over between day-parts (breakfast/lunch/…).
 * Extracted from MainPageLayout — a pure side effect that happened to live in
 * the layout root; it owns no layout concern of its own.
 */
const useMenuTimePeriodRollover = () => {
  const dispatch = useAppDispatch();
  const timezone = useAppSelector(selectActiveRestaurantTimezone);
  const stage = useAppSelector(selectedStageSelector);
  const modality = useAppSelector(selectCartModality);
  const infoSlashCommands = useAppSelector(selectInfoSlashCommandOptions);

  useEffect(() => {
    if (timezone) {
      const timer = setInterval(() => {
        if (getMenuUnificationFeatureFlag()) {
          dispatch(
            considerTimePeriodsForUnifiedMenu({ timezone, infoSlashCommands })
          );
        } else {
          dispatch(considerTimePeriods({ modality, timezone, stage }));
        }
      }, TIME_PERIOD_CHECK_INTERVAL);
      return () => {
        clearInterval(timer);
      };
    }
  }, [timezone, dispatch, modality, stage, infoSlashCommands]);

  // HITL-1749: rebuild the item list as soon as info_slash_commands or
  // its exclude list changes — Unleash usually resolves after the menu has
  // loaded — instead of waiting for the next rollover tick.
  useEffect(() => {
    if (timezone && getMenuUnificationFeatureFlag()) {
      dispatch(
        considerTimePeriodsForUnifiedMenu({ timezone, infoSlashCommands })
      );
    }
  }, [timezone, dispatch, infoSlashCommands]);
};

export default useMenuTimePeriodRollover;
